import './DropPanel.scss';
import Control from "../../Control";
import Delegate from "../../Delegate";
import NP from "../../NP";

export interface DropPanelOpeningArgs {
	X: number,
	Y: number,
	Cancel: boolean
}

export default class DropPanel extends Control {

	public EvOpening: Delegate;
	public EvOpened: Delegate;
	public EvClosing: Delegate;
	public EvClosed: Delegate;
	public EvFrameMouseDown: Delegate;
	public EvOutMouseDown: Delegate;
	public EvPositionChanged: Delegate;

	private _Mode: string;
	protected _CloseOnFrameMouseDown: boolean;
	private _AutoClose: boolean;
	private _ContentMouseDown: boolean;
	private _DroppedDown: boolean;
	private _Coords: object;
	private _ContentAutoFit: boolean;
	protected _CloseOnWindowResize: boolean;
	private _IsEscapeCloseEnabled: boolean;
	private _FocusOnOpen: boolean;
	private _FocusTimeout: number;
	protected _AutoDestroy: boolean;
	private _DropClass: string;
	private _ZIndex: number;

	protected _contentDomNode: HTMLElement;
	private _isInitialized: boolean;
	private _cntMD: boolean;
	_back: HTMLElement;
	private _bindedOnDocumentMouseDown: Function;
	private _focusTimeout: any;
	private _someWidth: number;
	private _someHeight: number;


	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this.EvOpening = new Delegate();
		this.EvOpened = new Delegate();
		this.EvClosing = new Delegate();
		this.EvClosed = new Delegate();
		this.EvFrameMouseDown = new Delegate();
		this.EvOutMouseDown = new Delegate();
		this.EvPositionChanged = new Delegate();

		this._Mode = '';
		this._CloseOnFrameMouseDown = true;
		this._AutoClose = false;
		this._ContentMouseDown = false;
		this._DroppedDown = false;
		this._Coords = null;
		this._ContentAutoFit = false;
		this._CloseOnWindowResize = true;
		this._IsEscapeCloseEnabled = true;
		this._FocusOnOpen = true;
		this._FocusTimeout = 0;
		this._AutoDestroy = false;
		this._DropClass = null;
		this._ZIndex = null;


		super._initFields(settings);

		if (!this._ParentNode)
			this._ParentNode = document.body;

		this._IsVisible = false;
		this._TabIndex = 0;
	}

	getCloseOnFrameMouseDown()
	{
		return this._CloseOnFrameMouseDown;
	}

	getAutoClose()
	{
		return this._AutoClose;
	}

	getDroppedDown()
	{
		return this._DroppedDown;
	}

	getCloseOnWindowResize()
	{
		return this._CloseOnWindowResize;
	}

	getIsEscapeCloseEnabled()
	{
		return this._IsEscapeCloseEnabled;
	}

	_render()
	{
		this._initComponent();
		this.addClass('dropdown');

		if (this._ZIndex)
			this._root.style.zIndex = this._ZIndex + '';
		this._contentDomNode = NP.createNode(this._root, 'dropdown__content');
		this._setContentToNode(this._Content, this._contentDomNode, "Content", true);

		if (this._Width)
		{
			let w = this._Width;
			this._Width = null;
			this.setWidth(w);
		}
		if (this._Height)
		{
			let h = this._Height;
			this._Height = null;
			this.setHeight(h);
		}

		super._render();
		this._isInitialized = true;
	}

	updateSidePosition()
	{
		if (this._Mode == 'SideRight')
		{
			this._root.style.left = document.documentElement.clientWidth - this.getWidth() + 'px';
			this._root.style.height = document.documentElement.clientHeight + 'px';
		}
		else if (this._Mode === 'SideLeft')
		{
			this._root.style.left = '0';
			this._root.style.height = document.documentElement.clientHeight + 'px';
		}
	}

	_getContentWidth()
	{
		return this.getWidth() - (this._someWidth || 0);
	}

	_getContentHeight()
	{
		return this.getHeight() - (this._someHeight || 0);
	}

	_isOutMouseDown(evt: MouseEvent)
	{
		let coords = NP.getMouseCoordinates(evt);

		for (let panel of NP.DropPanel.OpenedPanels)
		{
			if (panel == this)
			{
				let rect = NP.getNodeRect(panel.getRoot());
				if (coords.X >= rect.X && coords.X < rect.X + rect.Width && coords.Y >= rect.Y && coords.Y < rect.Y + rect.Height)
					return false;
			}
		}
		return true;
	}

	_onDocumentMouseDown(panelOrEvent: any, args: any)
	{
		let evt = panelOrEvent instanceof Control ? args.Event : panelOrEvent;
		if (this._back)
		{
			this.EvFrameMouseDown.fire(this._back, {
				Event: evt
			});
			if (this._DroppedDown && NP.hasCssClass(evt.target, "dropdown__frame") && this._CloseOnFrameMouseDown)
				this.hide();
		}
		else
		{
			let isOutMouseDown = this._isOutMouseDown(evt);
			if (this._DroppedDown && isOutMouseDown)
				this.EvOutMouseDown.fire(this, {
					Event: evt
				});
			if (this._DroppedDown && this._AutoClose && !this._cntMD && isOutMouseDown)
			{
				let openedPanels = NP.DropPanel.OpenedPanels,
					 index = openedPanels.indexOf(this),
					 found = false;
				if (index > -1)
				{
					for (let i = index + 1; i < openedPanels.length; i++)
					{
						if (!openedPanels[i].getCloseOnFrameMouseDown() && !openedPanels[i].getAutoClose())
						{
							found = true;
							break;
						}
					}
				}
				if (!found)
					this.hide();
			}
			this._cntMD = false;
		}
	}

	setWidth(value: number, fireEvent?: boolean)
	{
		if (fireEvent !== false && this._isInitialized)
			this.EvSizeChanging.fire(this, {});
		if (!value)
		{
			this._root.style.width = "";
			this._Width = 0;
			if (this._Content instanceof Control && this._ContentAutoFit)
				this._Content.setWidth(null);
		}
		else
		{
			if (value !== this._Width)
			{
				this._Width = value;
				this._root.style.width = this._Width + "px";
				if (this._ContentAutoFit && this._Width && this._Content)
				{
					let content = NP.toArray(this._Content);
					for (let ctrl of content)
					{
						if (ctrl instanceof Control)
							ctrl.setWidth(this._getContentWidth());
					}
				}
			}
		}
		if (fireEvent !== false && this._isInitialized)
			this.EvSizeChanged.fire(this);
	}

	setHeight(value: number, fireEvent?: boolean)
	{
		if (fireEvent !== false && this._isInitialized)
			this.EvSizeChanging.fire(this);
		if (!value)
		{
			this._Height = 0;
			this._root.style.height = '';
			if (this._Content instanceof Control && this._ContentAutoFit)
				this._Content.setHeight(null);
		}
		else
		{
			if (value !== this._Height)
			{
				this._Height = value;
				this._root.style.height = this._Height + "px";
				if (this._Content instanceof Control && this._ContentAutoFit)
					this._Content.setHeight(this._getContentHeight());
			}
		}
		if (fireEvent !== false && this._isInitialized)
			this.EvSizeChanged.fire(this);
	}

	setContent(value: object)
	{
		this._setContentToNode(value, this._contentDomNode, "Content", true);
	}

	updateContentSize()
	{
		if (this._ContentAutoFit && this._Width && this._Content)
		{
			for (let ctrl of NP.toArray(this._Content))
			{
				if (ctrl instanceof Control)
					ctrl.setWidth(this._getContentWidth());
			}
		}
		if (this._Content instanceof Control && this._ContentAutoFit && this._Height)
			this._Content.setHeight(this._getContentHeight());
	}

	setPosition(left: number, top: number)
	{
		this._root.style.left = left != null ? left + 'px' : this._root.style.left;
		this._Left = parseInt(this._root.style.left) ? parseInt(this._root.style.left) : 0;
		this._root.style.top = top != null ? top + 'px' : this._root.style.top;
		this._Top = parseInt(this._root.style.top) ? parseInt(this._root.style.top) : 0;
		this.EvPositionChanged.fire(this);
	}

	setPositionAnimate(coordsX: number, coordsY: number, originX?: number, originY?: number)
	{
		this.addClass('dropdown_hid dropdown_vis-check');
		this._root.style.webkitTransformOrigin =
			 this._root.style.transformOrigin = originX + 'px ' + originY + 'px';
		this.setPosition(coordsX, coordsY);

		setTimeout(() => this.removeClass('dropdown_hid dropdown_vis-check'), 0);
	}

	setIsVisible(value: boolean)
	{
		this._IsVisible = !!value;
	}

	show(left?: number, top?: number, notCreateFrame?: boolean)
	{
		if (this._focusTimeout)
			clearTimeout(this._focusTimeout);
		this._focusTimeout = null;
		if (!this._DroppedDown)
		{
			let oldOverflow = document.body.style.overflow;
			document.body.style.overflow = 'hidden';
			let args = {
				X: left ? left : 0,
				Y: top ? top : 0,
				Cancel: false
			} as DropPanelOpeningArgs;
			this.EvOpening.fire(this, args);
			if (args.Cancel)
				return false;
			this._root.style.visibility = "hidden";
			if (NP.isFullscreen())
				NP.getFullscreenElement().appendChild(this._root);
			else
				this._ParentNode.appendChild(this._root);
			NP.DropPanel.OpenedPanels.push(this);
			if (notCreateFrame)
			{
				this._back = null;
				if (this._CloseOnFrameMouseDown)
				{
					if (this._bindedOnDocumentMouseDown)
						document.documentElement.removeEventListener(NP.isTouchDevice() ? 'touchstart' : "mousedown", <any>this._bindedOnDocumentMouseDown, false);
					this._bindedOnDocumentMouseDown = this._onDocumentMouseDown.bind(this);
					document.documentElement.addEventListener(NP.isTouchDevice() ? 'touchstart' : "mousedown", <any>this._bindedOnDocumentMouseDown, false);
				}
			}
			else
			{
				this._back = NP.parseHTML("<div class='dropdown__frame'></div>");
				this._back.id = this.getId() + "_frame";
				if (this._ZIndex)
					this._back.style.zIndex = this._ZIndex + '';
				if (this._DropClass)
					NP.addCssClass(this._back, this._DropClass);

				if (this._root.parentNode)
					this._root.parentNode.insertBefore(this._back, this._root);

				this._addEvent(this._back, NP.isTouchDevice() ? "touchstart" : 'mousedown', this._onDocumentMouseDown);
			}
			this._Left = args.X;
			this._root.style.left = args.X + 'px';
			this._Top = args.Y;
			this._root.style.top = args.Y + 'px';
			this._root.style.visibility = "";
			this._DroppedDown =
				 this._IsVisible = true;
			this.updateSidePosition();
			super.show();
			if (this._FocusOnOpen)
				this._focusTimeout = setTimeout(this.setFocus.bind(this), this._FocusTimeout);
			this._someWidth = NP.getCssStyle(this._contentDomNode, 'paddingLeft', true) +
				 NP.getCssStyle(this._contentDomNode, 'paddingRight', true);
			this._someHeight = NP.getCssStyle(this._contentDomNode, 'paddingTop', true) +
				 NP.getCssStyle(this._contentDomNode, 'paddingBottom', true);
			this.EvOpened.fire(this); // обновлять размеры надо после кидания события
			this.addClass('dropdown_vis');
			this.updateContentSize();
			document.body.style.overflow = oldOverflow;
		}
	}

	showContext(left: number, top: number, animate?: boolean)
	{
		this.setData({X: left, Y: top}, 'ContextCoords');
		NP.showDropPanel(this, {
			X: left,
			Y: top,
			Width: 0,
			Height: 0
		}, NP.LTRB.Bottom, null, animate);
	}

	hide(e?: object)
	{
		if (this._focusTimeout)
			clearTimeout(this._focusTimeout);
		this._focusTimeout = null;
		if (this._DroppedDown)
		{
			let args = {
				IsCancelClose: false
			};
			this.EvClosing.fire(this, args);
			if (args.IsCancelClose)
				return;
			if (this._back)
			{
				this._removeAllEvents(this._back);
				if (this._back.parentNode)
					this._back.parentNode.removeChild(this._back);
				this._back = null;
			}
			else if (this._bindedOnDocumentMouseDown)
				document.documentElement.removeEventListener("mousedown", <any>this._bindedOnDocumentMouseDown, false);
			var openedPanels = NP.DropPanel.OpenedPanels;
			NP.removeFromArray(openedPanels, this);
			super.hide();
			if (this._root.parentNode)
				this._root.parentNode.removeChild(this._root);
			if (this._FocusOnOpen && openedPanels.length > 0 &&
				 openedPanels[openedPanels.length - 1]._FocusOnOpen &&
				 openedPanels[openedPanels.length - 1]._focusTimeout == null &&
				 document.activeElement == document.body)
			{
				openedPanels[openedPanels.length - 1].setFocus();
			}
			this._DroppedDown =
				 this._IsVisible = false;
			this.removeClass('dropdown_vis');
			this.EvClosed.fire(this, e);
		}
		if (this._AutoDestroy)
			setTimeout(() => this.destroy(), 10);
	}

	putToNode(node: HTMLElement)
	{
		this._ParentNode = node;
	}

	destroy()
	{
		if (!this.isLive())
			return;
		this.hide();
		super.destroy();
	}

	static closeNonDialogPanels()
	{
		let panels = NP.DropPanel.OpenedPanels;
		for (let i = panels.length - 1; i > -1; i--)
		{
			if (panels[i].getIsEscapeCloseEnabled() && !(panels[i] instanceof NP.Dialog))
				panels[i].hide();
		}
	}

};

NP.DropPanel = DropPanel;

NP.DropPanel.OpenedPanels = [];